import { useDispatch, useSelector } from "react-redux";
import "./css/plantDetail.scss";
import { Button, Icon, Loader, Modal } from "@scuf/common";
import {
  removeSelectedVM,
  setLoading,
  setSelectedView,
  getShutDownData,
  getRebootData,
  setLoggedIn,
  getDetails,
  getRestoreSnapshot,
  getCreateSnapshot,
  getStartData,
  setRebootStatus,
  setShutDownStatus,
  setRestoreSnapshot,
  setCreateSnapshot,
  getPowerOff,
  getPowerOn,
  getResetStatus,
  setPowerOff,
  setPowerOn,
  setResetStatus,
  getMountISO,
  getUnMountISO,
  setISOListStatus,
  setMountISO,
  setListSnapshot,
  setUnMountISO,
  getDeleteSnapshot,
  setDeleteSnapshot,
} from "../../../store/action";
import DeviceDetails from "./deviceDetails";
import { useEffect, useState } from "react";
import { AppState } from "../../../../common/store/combinedReducer";
import noVmIcon from "../../../../common/assets/noVmIcon.png";
import warning from "../../../../common/assets/warning.png";
import _ from "lodash";
import { customToast } from "../../../../App";
import { REQUIRED_PERMISSIONS } from "../../../../common/authentication/config";
import ISOModal from "../../../../common/utility/ISOModal";
import SnapshotModal from "../../../../common/utility/Snapshot/SnapshotModal";
// import ConfirmationModal from "../../../../common/utility/ConfirmationModal/ConfirmationModal";
import { addSelectedID } from "../../../../common/utility/plantDetailUtils";
import {
  ConfirmModal,
  VMAlert,
} from "../../../../common/utility/ConfirmationModal/ConfirmModalScuff";

const PlantDetail = (props: any) => {
  const dispatch = useDispatch();
  const [clearAll, setClearAll] = useState(false);
  const [disableShutDown, setShutDown] = useState(true);
  const [disableRestart, setRestart] = useState(true);
  const [disableRestore, setRestoreSnapshotDisable] = useState(true);
  const [disableCreateSnapshot, setCreateSnapshotDisable] = useState(true);
  const [closeConfirmModal, setCloseConfirmModal] = useState(false);
  const [header, setHeader] = useState("");
  const [contentVal, setContent] = useState("");
  const [poweredVm, setPoweredVm] = useState<any>();
  const [orgId, setOrgId] = useState("");
  const [clicked, setClicked] = useState(false);
  const [openVm, setOpenVm] = useState(false);
  const [showIso, setShowIso] = useState(false);
  const [selectedIso, setSelectedIso] = useState<any>(null);
  const [isoSearch, setISOSearch] = useState("");
  const [snapShotShow, setSnapShotShow] = useState(false);
  const [newSnapshotName, setNewSnapshotName] = useState(null);
  const [selectedSnapshot, setSelectedSnapshot] = useState(null);
  // const [selectedSnapDelete, setSelectedSnapDelete] = useState([]);

  const orgData = props.orgData;

  const orgDataStatus = useSelector((state: AppState) => {
    return state.reducer.orgDataStatus;
  });
  const selectedVM = useSelector((state: AppState) => {
    return state.reducer.selectedVM;
  });
  const rebootStatus = useSelector((state: AppState) => {
    return state.reducer.rebootStatus;
  });
  const shutDownStatus = useSelector((state: AppState) => {
    return state.reducer.shutDownStatus;
  });
  const createSnapShotStatus = useSelector((state: AppState) => {
    return state.reducer.createSnapShotStatus;
  });
  const restoreSnapShotStatus = useSelector((state: AppState) => {
    return state.reducer.restoreSnapShotStatus;
  });
  const powerOffStatus = useSelector((state: AppState) => {
    return state.reducer.powerOffStatus;
  });
  const powerOnStatus = useSelector((state: AppState) => {
    return state.reducer.powerOnStatus;
  });
  const resetStatus = useSelector((state: AppState) => {
    return state.reducer.resetStatus;
  });
  const isoListReducer = useSelector((state: AppState) => {
    return state.reducer.isoList;
  });
  const isoListStatus = useSelector((state: AppState) => {
    return state.reducer.isoListStatus;
  });
  const isoMountStatus = useSelector((state: AppState) => {
    return state.reducer.isoMountStatus;
  });
  const isoMountMessage = useSelector((state: AppState) => {
    return state.reducer.isoMountMessage;
  });
  const snapShotList = useSelector((state: AppState) => {
    return state.reducer.snapShotList;
  });
  const snapShotListStatus = useSelector((state: AppState) => {
    return state.reducer.snapShotListStatus;
  });
  const isoUnmountStatus = useSelector((state: AppState) => {
    return state.reducer.isoUnmountStatus;
  });
  const isoUnmountMessage = useSelector((state: AppState) => {
    return state.reducer.isoUnmountMessage;
  });
  const deleteSnapShotStatus = useSelector((state: AppState) => {
    return state.reducer.deleteSnapShotStatus;
  });
  const [selectedSnapIndex, setSelectedSnapIndex] = useState(0);
  const [ISOList, setISOLiSt] = useState<any>(isoListReducer);
  const [validName, setValidName] = useState<boolean>(true);
  const [namePresent, setNamePresent] = useState<boolean>(false);

  const escFunction = (event: any) => {
    if (event.key === "Escape") {
      setCloseConfirmModal(false);
      handleClearAll();
      powerActionCancelled();
    }
  };
  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      dispatch(setListSnapshot({ status: 0, data: [] }));

      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  useEffect(() => {
    if (isoListStatus === 200) {
      dispatch(setLoading(false));
      setShowIso(true);
      setISOLiSt(isoListReducer);
      setISOListStatus(0);
      dispatch(setISOListStatus(0));
    } else if (isoListStatus !== 200 && isoListStatus !== 0) {
      customToast("Unable to fetch ISO list", "critical");
      dispatch(setLoading(false));
    }
  }, [isoListReducer, isoListStatus]);

  useEffect(() => {
    if (isoMountStatus === 409) {
      dispatch(setLoading(false));
      customToast(isoMountMessage, "critical");
      dispatch(setMountISO({ status: 0, data: "" }));
      dispatch(removeSelectedVM());
    } else {
      dispatch(setLoading(false));
      dispatch(removeSelectedVM());
    }
  }, [isoMountStatus, isoMountMessage]);

  useEffect(() => {
    if (snapShotListStatus === 200) {
      dispatch(setLoading(false));
      if (snapShotList?.length === 3 && header === "Create Snapshot") {
        setCloseConfirmModal(true);
      } else setSnapShotShow(true);
      setSelectedSnapIndex(0);
    } else {
      dispatch(setLoading(false));
      // dispatch(setListSnapshot({ status: 0, data: [] }));
    }
  }, [snapShotList, snapShotListStatus]);

  useEffect(() => {
    if (isoUnmountStatus === 409) {
      dispatch(setLoading(false));
      customToast(isoUnmountMessage, "critical");
      dispatch(setUnMountISO({ status: 0, data: "" }));
      dispatch(removeSelectedVM());
    } else {
      dispatch(setLoading(false));
      dispatch(removeSelectedVM());
    }
  }, [isoUnmountStatus, isoUnmountMessage]);

  const handleClearAll = () => {
    setClearAll(true);
    setShutDown(true);
    setRestart(true);
    setCreateSnapshotDisable(true);
    setRestoreSnapshotDisable(true);
    setSelectedSnapIndex(0);
    setSelectedSnapshot(null);
    setNewSnapshotName(null);
    setSelectedIso(null);
    setValidName(true);
    setNamePresent(false);
    orgData?.vmDetails?.forEach((element: any) => {
      element.checked = false;
    });
    dispatch(removeSelectedVM());
  };
  // const addSelectedID = () => {
  //   const vmId: any = [];
  //   _.forEach(selectedVM, (data: any) => {
  //     data && vmId.push(data?.id);
  //   });
  //   return vmId;
  // };

  const powerActionCancelled = () => {
    if (!orgData?.vmDetails || !poweredVm?.id) return;

    orgData.vmDetails.forEach((element: any) => {
      if (element.id !== poweredVm.id) return;

      switch (element.status) {
        case "POWERED_ON":
          if (powerOffStatus === 0) {
            element.isOn = true;
            element.isIntermediate = false;
          }
          break;
        case "POWERED_OFF":
          if (powerOnStatus === 0) {
            element.isOn = false;
            element.isIntermediate = false;
          }
          break;
        case "SUSPENDED":
          element.isOn = false;
          element.isIntermediate = false;
          break;
        default:
          break;
      }
    });
  };

  const handleUnmountClick = () => {
    // dispatch(setLoading(true));
    dispatch(
      getUnMountISO({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
      })
    );
  };

  const handlePowerOnClick = () => {
    // dispatch(setLoading(true));
    dispatch(
      getPowerOn({
        vmId: poweredVm.id,
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
      })
    );
  };

  const handlePowerOffClick = () => {
    // dispatch(setLoading(true));
    dispatch(
      getPowerOff({
        vmId: poweredVm.id,
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
      })
    );
  };

  const handleResetClick = () => {
    // const vm = addSelectedID();
    // dispatch(setLoading(true));
    dispatch(
      getResetStatus({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
      })
    );
  };
  const handleShutDownClick = () => {
    // const vm = addSelectedID();
    // dispatch(setLoading(true));
    dispatch(
      getShutDownData({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
      })
    );
  };

  // const handleRestartClick = () => {
  //   const vm = addSelectedID();
  //   dispatch(setLoading(true));
  //   if (_.every(selectedVM, ["status", "POWERED_ON"]) === true) {
  //     dispatch(
  //       getRebootData({
  //         vmId: vm,
  //         authorization: localStorage.getItem("access_token"),
  //         siteId: orgData?.siteId,
  //         orgId: orgId,
  //       })
  //     );
  //   } else if (_.every(selectedVM, ["status", "POWERED_OFF"]) === true) {
  //     dispatch(
  //       getStartData({
  //         vmId: vm,
  //         authorization: localStorage.getItem("access_token"),
  //         siteId: orgData?.siteId,
  //         orgId: orgId,
  //       })
  //     );
  //   } else {
  //     if (_.some(selectedVM, ["status", "POWERED_ON"]) === true) {
  //       const vmOff = getVmId("POWERED_ON");
  //       dispatch(
  //         getRebootData({
  //           vmId: vmOff,
  //           authorization: localStorage.getItem("access_token"),
  //           siteId: orgData?.siteId,
  //           orgId: orgId,
  //         })
  //       );
  //     }
  //     if (_.some(selectedVM, ["status", "POWERED_OFF"]) === true) {
  //       const vmOff = getVmId("POWERED_OFF");
  //       dispatch(
  //         getStartData({
  //           vmId: vmOff,
  //           authorization: localStorage.getItem("access_token"),
  //           siteId: orgData?.siteId,
  //           orgId: orgId,
  //         })
  //       );
  //     }
  //   }
  // };
  const deleteSnapShot = () => {
    // const vm = addSelectedID();
    // dispatch(setLoading(true));
    dispatch(
      getDeleteSnapshot({
        snapshotId: selectedSnapshot,
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
      })
    );
    setSelectedSnapIndex(0);
    setSelectedSnapshot(null);
  };
  const restoreSnapShot = () => {
    // const vm = addSelectedID();
    // dispatch(setLoading(true));
    dispatch(
      getRestoreSnapshot({
        snapshotId: selectedSnapshot,
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
      })
    );
    setSelectedSnapIndex(0);
    setSelectedSnapshot(null);
  };
  const createSnapShot = () => {
    // dispatch(setLoading(true));
    dispatch(
      getCreateSnapshot({
        vmId: addSelectedID(selectedVM),
        authorization: localStorage.getItem("access_token"),
        siteId: orgData?.siteId,
        orgId: orgId,
        snapshotName: newSnapshotName,
      })
    );
    setNewSnapshotName(null);
    setSelectedSnapshot(null);
  };

  useEffect(() => {
    setClearAll(true);
    setShutDown(true);
    setRestart(true);
    setCreateSnapshotDisable(true);
    setRestoreSnapshotDisable(true);
    const val = orgData?.id?.split(":");
    val && val.length > 0 && setOrgId(val[val?.length - 1]);
  }, [orgData]);

  useEffect(() => {
    const handleStatus = (
      status: number,
      expectedStatuses: number[],
      clearAction: () => void,
      resetAction: () => any
    ) => {
      if (expectedStatuses.includes(status)) {
        dispatch(setLoading(false));
        clearAction();
        dispatch(resetAction());
      }
    };

    handleStatus(shutDownStatus, [200, 201, 204], handleClearAll, () =>
      setShutDownStatus(0)
    );
    handleStatus(rebootStatus, [200, 201, 204], handleClearAll, () =>
      setRebootStatus(0)
    );
    handleStatus(restoreSnapShotStatus, [200, 201, 204], handleClearAll, () =>
      setRestoreSnapshot(0)
    );
    handleStatus(createSnapShotStatus, [200, 201, 204], handleClearAll, () =>
      setCreateSnapshot(0)
    );
    handleStatus(powerOffStatus, [200, 201, 204], handleClearAll, () =>
      setPowerOff(0)
    );
    handleStatus(powerOnStatus, [200, 201, 204], handleClearAll, () =>
      setPowerOn(0)
    );
    handleStatus(resetStatus, [200, 201, 204], handleClearAll, () =>
      setResetStatus(0)
    );
    handleStatus(deleteSnapShotStatus, [200, 201, 204], handleClearAll, () =>
      setDeleteSnapshot(0)
    );

    if (orgDataStatus !== 0) {
      dispatch(setLoading(false));
    }
  }, [
    orgDataStatus,
    shutDownStatus,
    rebootStatus,
    restoreSnapShotStatus,
    createSnapShotStatus,
    powerOffStatus,
    powerOnStatus,
    resetStatus,
    deleteSnapShotStatus,
  ]);

  return (
    <div
      data-testid="plant-detail-wrapper"
      className={
        REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every((p: string) =>
          props.orgData?.permissions?.includes(p)
        )
          ? "plant-wrapper"
          : "plant-wrapper-nopermission"
      }
    >
      {REQUIRED_PERMISSIONS.VIEW_CUSTOMER_PRIME_SPACE.every((p: string) =>
        props.orgData?.permissions?.includes(p)
      ) && props.orgData?.vmDetails?.length > 0 ? (
        <>
          {/* {closeConfirmModal && (
            <ConfirmationModal
              header={header}
              orgData={orgData}
              orgId={orgId}
              snapShotList={snapShotList}
              poweredVm={poweredVm}
              selectedVM={selectedVM}
              setCloseConfirmModal={setCloseConfirmModal}
              handleClearAll={handleClearAll}
              powerActionCancelled={powerActionCancelled}
              contentVal={contentVal}
              restoreSnapShot={restoreSnapShot}
              createSnapShot={createSnapShot}
              deleteSnapShot={deleteSnapShot}
              handleShutDownClick={handleShutDownClick}
              handlePowerOnClick={handlePowerOnClick}
              handlePowerOffClick={handlePowerOffClick}
              handleResetClick={handleResetClick}
              handleUnmountClick={handleUnmountClick}
            />
          )} */}
          {
            <ConfirmModal
              setCloseConfirmModal={setCloseConfirmModal}
              handleClearAll={handleClearAll}
              powerActionCancelled={powerActionCancelled}
              header={header}
              snapShotList={snapShotList}
              selectedVM={selectedVM}
              poweredVm={poweredVm}
              closeConfirmModal={closeConfirmModal}
              contentVal={contentVal}
              restoreSnapShot={restoreSnapShot}
              createSnapShot={createSnapShot}
              deleteSnapShot={deleteSnapShot}
              handleShutDownClick={handleShutDownClick}
              handlePowerOnClick={handlePowerOnClick}
              handlePowerOffClick={handlePowerOffClick}
              handleResetClick={handleResetClick}
              handleUnmountClick={handleUnmountClick}
            />
          }
          {
            <VMAlert
              setClicked={setClicked}
              setOpenVm={setOpenVm}
              openVm={openVm}
              clicked={clicked}
              orgData={orgData}
            />
          }
          {REQUIRED_PERMISSIONS.CAN_VIEW_ISO.every((p: string) =>
            props.orgData?.permissions?.includes(p)
          ) && (
            <ISOModal
              showIso={showIso}
              setShowIso={setShowIso}
              isoSearch={isoSearch}
              setISOSearch={setISOSearch}
              ISOList={ISOList}
              setISOLiSt={setISOLiSt}
              isoListReducer={isoListReducer}
              selectedIso={selectedIso}
              setSelectedIso={setSelectedIso}
              setHeader={setHeader}
              setContent={setContent}
              selectedVM={selectedVM}
              addSelectedID={addSelectedID}
              orgData={orgData}
              orgId={orgId}
              data-testid="iso-modal"
            />
          )}
          {
            <SnapshotModal
              snapShotShow={snapShotShow}
              setSnapShotShow={setSnapShotShow}
              header={header}
              snapShotList={snapShotList}
              newSnapshotName={newSnapshotName}
              setNewSnapshotName={setNewSnapshotName}
              selectedSnapshot={selectedSnapshot}
              setSelectedSnapshot={setSelectedSnapshot}
              selectedSnapIndex={selectedSnapIndex}
              setSelectedSnapIndex={setSelectedSnapIndex}
              setCloseConfirmModal={setCloseConfirmModal}
              setValidName={setValidName}
              validName={validName}
              setNamePresent={setNamePresent}
              namePresent={namePresent}
            />
          }
          {REQUIRED_PERMISSIONS.SELF_SERVICE_INDIVIDUAL_VMS.every((p: string) =>
            props.orgData?.permissions?.includes(p)
          ) ? (
            <div className="button-group">
              <div className="button1-group">
                <Button
                  data-testid="plant-detail-restart"
                  type="primary"
                  disabled={disableRestart}
                  className={
                    disableRestart ? "button1-disabled" : "button1-active"
                  }
                  iconRoot="global"
                  icon="redo"
                  content="Reset"
                  iconPosition="left"
                  size="small"
                  onClick={() => {
                    if (orgData && orgData.IsVCDAlive === false) {
                      customToast(
                        "This site is not available currently, please try after sometime.",
                        "critical"
                      );
                      handleClearAll();
                    } else setCloseConfirmModal(true);
                    setHeader("Reset");
                    setContent("reset");
                  }}
                />
                <Button
                  data-testid="plant-detail-shutdown"
                  type="primary"
                  disabled={disableShutDown}
                  className={
                    disableShutDown ? "button1-disabled" : "button1-active"
                  }
                  icon="power"
                  content="Shutdown"
                  iconPosition="left"
                  size="small"
                  onClick={() => {
                    if (orgData && orgData.IsVCDAlive === false) {
                      customToast(
                        "This site is not available currently, please try after sometime.",
                        "critical"
                      );
                      handleClearAll();
                    } else setCloseConfirmModal(true);
                    setHeader("Shutdown");
                    setContent("shutdown");
                  }}
                />
                {/* <Button
                  data-testid="plant-detail-restore"
                  type="primary"
                  disabled={disableRestore}
                  className={
                    disableRestore ? "button1-disabled" : "button1-active"
                  }
                  icon={
                    disableRestore ? (
                      <img className="icon-restore" src={restoreSnap} />
                    ) : (
                      <img className="icon-restore" src={restoreSnapEnable} />
                    )
                  }
                  content="&nbsp; Restore Snapshot"
                  iconPosition="left"
                  size="small"
                  onClick={() => {
                    if (orgData && orgData.IsVCDAlive === false) {
                      customToast(
                        "This site is not available currently, please try after sometime.",
                        "critical"
                      );
                      handleClearAll();
                    } else setCloseConfirmModal(true);
                    setHeader("Restore Snapshot");
                    setContent("restore snapshot for");
                  }}
                />
                <Button
                  data-testid="plant-detail-snapshot"
                  type="primary"
                  disabled={disableCreateSnapshot}
                  className={
                    disableCreateSnapshot
                      ? "button1-disabled"
                      : "button1-active"
                  }
                  icon={
                    disableCreateSnapshot ? (
                      <img className="icon-restore" src={createSnap} />
                    ) : (
                      <img className="icon-restore" src={createSnapEnable} />
                    )
                  }
                  content="&nbsp; Create Snapshot"
                  iconPosition="left"
                  size="small"
                  onClick={() => {
                    if (orgData && orgData.IsVCDAlive === false) {
                      customToast(
                        "This site is not available currently, please try after sometime.",
                        "critical"
                      );
                      handleClearAll();
                    } else setCloseConfirmModal(true);
                    setHeader("Create Snapshot");
                    setContent("create snapshot for");
                  }}
                /> */}
              </div>
              <Button
                type="link"
                data-testid="plant-detail-clearall"
                className={
                  disableCreateSnapshot &&
                  disableRestore &&
                  disableRestart &&
                  disableShutDown
                    ? "button-clear button-clear-disable"
                    : "button-clear"
                }
                disabled={
                  disableCreateSnapshot &&
                  disableRestore &&
                  disableRestart &&
                  disableShutDown
                    ? true
                    : false
                }
                content="Clear All"
                onClick={() => handleClearAll()}
              />
            </div>
          ) : null}
          <div className="detail-outer-wrapper">
            {orgData && orgData?.vmDetails.length > 0 ? (
              <DeviceDetails
                // data-testid="plant-detail-device-details"
                plantName={orgData?.siteId}
                orgId={orgId}
                orgData={orgData}
                vmDetails={orgData?.vmDetails}
                clearAll={clearAll}
                setClearAll={setClearAll}
                handleClearAll={handleClearAll}
                disabled={disableRestart}
                setRestart={setRestart}
                shutDownClicked={disableShutDown}
                setShutDown={setShutDown}
                // setRestoreSnapshot={setRestoreSnapshotDisable}
                setCreateSnapshotDisable={setCreateSnapshotDisable}
                setHeader={setHeader}
                setContent={setContent}
                setCloseConfirmModal={setCloseConfirmModal}
                setPoweredVm={setPoweredVm}
                setClicked={setClicked}
                clicked={clicked}
                setOpenVm={setOpenVm}
                openVm={openVm}
                showIso={showIso}
                setShowIso={setShowIso}
                selectedIso={selectedIso}
                setSnapShotShow={setSnapShotShow}
              />
            ) : (
              <div className="no-data-available">
                <img className="icon-restore" src={noVmIcon} />
                <span className="no-detail-text">
                  THIS SITE HAS NO AVAILABLE VIRTUAL MACHINE(S) FOR YOU
                </span>
                <span className="no-detail-text">
                  Try selecting a different site
                </span>
              </div>
            )}
          </div>
        </>
      ) : REQUIRED_PERMISSIONS.ACA_HONEYWELL_TRAINING_ADMIN_DASHBOARD.every(
          (p: string) => props.orgData?.permissions?.includes(p)
        ) ? (
        <div className="no-data-available">
          <img className="icon-restore" src={warning} />
          <span className="no-detail-text">NO DATA AVAILABLE</span>
          <span className="no-detail-text">
            No Data is currently available for display
          </span>
          <span className="no-detail-text">
            To perform administrative actions, please click the "Course Admin"
            button
          </span>
        </div>
      ) : (
        <span data-testid="plant-detail-no-data" className="no-data-available">
          {orgDataStatus !== 0 ||
          orgData?.vmDetails.length === 0 ||
          (orgDataStatus !== 200 && orgDataStatus !== 0) ? (
            <>
              <img className="icon-restore" src={noVmIcon} />
              <span className="no-detail-text">
                THIS SITE HAS NO AVAILABLE VIRTUAL MACHINE(S) FOR YOU
              </span>
              <span className="no-detail-text">
                Try selecting a different site
              </span>
            </>
          ) : null}
        </span>
      )}
    </div>
  );
};
export default PlantDetail;
